export const APPROVED = "APPROVED"
export const REJECTED = "REJECTED"
export const AFFIRM = "Affirm"
export const YES = "Yes"
export const NO = "No"
export const WALKIN = "Walk In"
export const ORDER_APPROVAL = "approval"
export const ORDER_APPROVE = "ORDER_APPROVE"
